import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProfileState, profileFeatureKey } from './profile.reducer';

const selectProfileState = createFeatureSelector<ProfileState>(profileFeatureKey);

export const selectProfile = createSelector(selectProfileState, (state) => state.profile);
